// extracted by mini-css-extract-plugin
export default {"deleteBtn":"DeleteButton_deleteBtn__SVXuC"};